import type { ParteProcesso, TipoSolicitacaoAlteracao } from './arbitralDetailTypes';

export type EscopoDetalheArbitral = 'empresa' | 'advogado';

export type PoloSolicitacaoArbitral = 'REQUERENTE' | 'REQUERIDO' | 'AMBOS';

export interface EscopoDeSolicitacaoArbitral {
  polo: PoloSolicitacaoArbitral;
  parteArbitralRepresentadaId: string | null;
  tiposPermitidos: TipoSolicitacaoAlteracao[];
}

export interface CapacidadesProcessoArbitral {
  podeCancelarProcesso: boolean;
  podeEditarIdentificacao: boolean;
  podeRegistrarAndamento: boolean;
  podeResponderPendencia: boolean;
  podeEnviarMensagemChat: boolean;
  escopoDeSolicitacao: EscopoDeSolicitacaoArbitral;
}

const TIPOS_SOLICITACAO_DA_EMPRESA: TipoSolicitacaoAlteracao[] = [
  'INCLUSAO_PARTE',
  'ADICIONAR_ADVOGADO',
  'ALTERACAO_PARTE',
  'EXCLUSAO_PARTE',
  'ALTERACAO_DADOS',
  'ALTERACAO_BREVE_RELATO',
  'ALTERACAO_PEDIDO',
  'IMPUGNACAO_ARBITRO',
];

export const podeSolicitarSobreParte = (
  escopo: EscopoDeSolicitacaoArbitral,
  parteId: string,
): boolean => escopo.polo !== 'REQUERIDO' || escopo.parteArbitralRepresentadaId === parteId;

const POLOS_REQUERIDO: ParteProcesso['tipo'][] = [
  'REQUERIDO',
  'ADVOGADO_REQUERIDO',
  'REPRESENTANTE_REQUERIDO',
];

export const escopoDeSolicitacaoDaEmpresa = (
  partes: ParteProcesso[],
): EscopoDeSolicitacaoArbitral => {
  const minhaParte = partes.find((parte) => parte.isCurrentUser);
  const souRequerido = !!minhaParte && POLOS_REQUERIDO.includes(minhaParte.tipo);
  return {
    polo: souRequerido ? 'REQUERIDO' : 'AMBOS',
    parteArbitralRepresentadaId: minhaParte?.id ?? null,
    tiposPermitidos: TIPOS_SOLICITACAO_DA_EMPRESA,
  };
};
